// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MixOptimization_wrapper__29kEn"};